<div class="wrapper-md">
    <app-breadcrumbs [items]="[{ url: '/vaccination-documents', text: 'vaccinationDocument_listTitle' }]"></app-breadcrumbs>

    <header class="content-header">
        <h1>{{'vaccinationDocument_listTitle' | translate}}</h1>
        <aside>
            <button *ngIf="canEdit" type="button" class="btn btn-outline-primary" [routerLink]="['/vaccination-documents/add'] | localize">
                <i class="fi fi-rs-plus"></i>
                {{'add' | translate}}
            </button>
        </aside>
    </header>

    <form>
        <div class="row">
            <div class="col-md form-field">
                <app-select name="filterDoctor"
                            [placeholder]="'vaccinationDocument_lblProgram' | translate"
                            [options]="filters.program.options"
                            [multiple]="true"
                            [valueProperty]="'value'"
                            [displayProperty]="'text'"
                            [(ngModel)]="filters.program.value"
                            (selectionChange)="filter()">
                </app-select>
            </div>

            <div class="col-md form-field">
                <app-select name="filterFaculty"
                            [placeholder]="'vaccinationDocument_lblFaculty' | translate"
                            [options]="filters.faculty.options"
                            [multiple]="true"
                            [valueProperty]="'value'"
                            [displayProperty]="'text'"
                            [(ngModel)]="filters.faculty.value"
                            (selectionChange)="filter()">
                </app-select>
            </div>

            <div class="col-md form-field" *ngIf="filters.person.options.length > 1">
                <app-select name="filterPerson"
                            [placeholder]="'vaccinationDocument_lblPerson' | translate"
                            [options]="filters.person.options"
                            [multiple]="true"
                            [valueProperty]="'value'"
                            [displayProperty]="'text'"
                            [(ngModel)]="filters.person.value"
                            (selectionChange)="filter()">
                </app-select>
            </div>
        </div>
    </form>

    <app-table [rows]="items" [columns]="columns">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>
                    <div>{{row.Type}}</div>
                    <div class="text-sub" *ngIf="row.PolicyNumber">{{row.PolicyNumber}}</div>
                </td>
                <td>{{row.Expires | appDate}}</td>
                <td [class.d-none]="!canReview">
                    <div>{{row.OwnerFullName}}</div>
                    <div class="text-sub">{{row.OwnerUserName}}</div>
                </td>
                <td>
                    <app-vaccination-document-status [value]="row.Status"></app-vaccination-document-status>
                </td>
                <td>
                    <div class="table-actions">
                        <button *ngIf="checkDelete(row)"
                                type="button"
                                (click)="delete(row)"
                                class="btn btn-outline-primary btn-icon"
                                [ngbTooltip]="'delete' | translate">
                            <i class="fi fi-rs-trash"></i>
                        </button>

                        <button *ngIf="checkReview(row)"
                                type="button"
                                (click)="review(row)"
                                class="btn btn-outline-primary btn-icon"
                                [ngbTooltip]="'review' | translate">
                            <i class="fi fi-rs-text-check"></i>
                        </button>

                        <button *ngIf="row.FileName"
                                type="button"
                                (click)="download(row)"
                                class="btn btn-outline btn-icon"
                                [ngbTooltip]="'download' | translate">
                            <i class="fi fi-rs-download"></i>
                        </button>

                        <button type="button"
                                class="btn btn-outline btn-icon"
                                [routerLink]="['/vaccination-documents', row.Id] | localize"
                                [ngbTooltip]="'open' | translate">
                            <i class="fi fi-rs-angle-right"></i>
                        </button>
                    </div>
                </td>
            </tr>
        </ng-template>
    </app-table>
</div>
